import { MonthEnum } from './month.enum';

export enum MonthsOfYear {
  None = 0,
  January = 1 << MonthEnum.January,
  February = 1 << MonthEnum.February,
  March = 1 << MonthEnum.March,
  April = 1 << MonthEnum.April,
  May = 1 << MonthEnum.May,
  June = 1 << MonthEnum.June,
  July = 1 << MonthEnum.July,
  August = 1 << MonthEnum.August,
  September = 1 << MonthEnum.September,
  October = 1 << MonthEnum.October,
  November = 1 << MonthEnum.November,
  December = 1 << MonthEnum.December,

  AllMonths = January | February | March | April | May | June | July | August | September | October | November | December
}

export const MonthOfYearToBitMapping: Record<MonthEnum, MonthsOfYear> = {
  [MonthEnum.Invalid]: MonthsOfYear.None,
  [MonthEnum.January]: MonthsOfYear.January,
  [MonthEnum.February]: MonthsOfYear.February,
  [MonthEnum.March]: MonthsOfYear.March,
  [MonthEnum.April]: MonthsOfYear.April,
  [MonthEnum.May]: MonthsOfYear.May,
  [MonthEnum.June]: MonthsOfYear.June,
  [MonthEnum.July]: MonthsOfYear.July,
  [MonthEnum.August]: MonthsOfYear.August,
  [MonthEnum.September]: MonthsOfYear.September,
  [MonthEnum.October]: MonthsOfYear.October,
  [MonthEnum.November]: MonthsOfYear.November,
  [MonthEnum.December]: MonthsOfYear.December
};

export const BitToMonthOfYearMapping: Record<MonthsOfYear, MonthEnum> = {
  [MonthsOfYear.January]: MonthEnum.January,
  [MonthsOfYear.February]: MonthEnum.February,
  [MonthsOfYear.March]: MonthEnum.March,
  [MonthsOfYear.April]: MonthEnum.April,
  [MonthsOfYear.May]: MonthEnum.May,
  [MonthsOfYear.June]: MonthEnum.June,
  [MonthsOfYear.July]: MonthEnum.July,
  [MonthsOfYear.August]: MonthEnum.August,
  [MonthsOfYear.September]: MonthEnum.September,
  [MonthsOfYear.October]: MonthEnum.October,
  [MonthsOfYear.November]: MonthEnum.November,
  [MonthsOfYear.December]: MonthEnum.December,
  [MonthsOfYear.None]: MonthEnum.Invalid,
  [MonthsOfYear.AllMonths]: MonthEnum.January
};

export function MonthsOfYearToString(months: MonthsOfYear): string {
  switch (months) {
    case MonthsOfYear.AllMonths:
      return 'All Months';
    case MonthsOfYear.None:
      return 'Never';
    default: {
      const response: string[] = [];
      if (months & MonthsOfYear.January) response.push('Jan');
      if (months & MonthsOfYear.February) response.push('Feb');
      if (months & MonthsOfYear.March) response.push('Mar');
      if (months & MonthsOfYear.April) response.push('Apr');
      if (months & MonthsOfYear.May) response.push('May');
      if (months & MonthsOfYear.June) response.push('June');
      if (months & MonthsOfYear.July) response.push('July');
      if (months & MonthsOfYear.August) response.push('Aug');
      if (months & MonthsOfYear.September) response.push('Sept');
      if (months & MonthsOfYear.October) response.push('Oct');
      if (months & MonthsOfYear.November) response.push('Nov');
      if (months & MonthsOfYear.December) response.push('Dec');
      return response.join('');
    }
  }
}

export function MonthsOfYearToAbbrString(months: MonthsOfYear): string {
  switch (months) {
    case MonthsOfYear.AllMonths:
      return 'All';
    case MonthsOfYear.None:
      return '-';
    default: {
      const response: string[] = [];
      if (months & MonthsOfYear.January) response.push('Jan');
      if (months & MonthsOfYear.February) response.push('Feb');
      if (months & MonthsOfYear.March) response.push('Mar');
      if (months & MonthsOfYear.April) response.push('Apr');
      if (months & MonthsOfYear.May) response.push('May');
      if (months & MonthsOfYear.June) response.push('June');
      if (months & MonthsOfYear.July) response.push('July');
      if (months & MonthsOfYear.August) response.push('Aug');
      if (months & MonthsOfYear.September) response.push('Sept');
      if (months & MonthsOfYear.October) response.push('Oct');
      if (months & MonthsOfYear.November) response.push('Nov');
      if (months & MonthsOfYear.December) response.push('Dec');
      return response.join('');
    }
  }
}

export { MonthEnum };

